export default __webpack_public_path__ + "static/media/common-application-icon.8c29ce9c.svg";